import React, { useContext, useEffect, useState } from "react";
import { StyledDatagrid } from "../styles/ConectaZapPage";
import { ptBR } from "@material-ui/data-grid";
import { makeStyles, Typography } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { ButtonCancel } from "../../../components/modal/Modal";
import {
  getNumbersBlocked,
  removeNumberBlocked,
} from "../../../repositories/portal_api/ConectaZap";
import { GlobalContext } from "../../../contexts/GlobalContext";
import { notify } from "../../../utils/notify";
import MaskService from "../../../utils/mask/maskService";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      "& .super-app-theme--usa-row": {
        backgroundColor: "#F3F3F3",
      },
    },
  };
});

const TabPanelBlockedNumbers = () => {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const { companyUser } = useContext(GlobalContext);

  const columns = [
    {
      field: "phoneNumber",
      headerName: "Número",
      sortable: false,
      flex: 1,
      valueFormatter: (params) => {
        const countryCode = params.value.substring(0, 2);
        const formatedNumber = MaskService.toMask(
          "cel-phone",
          params.value.substring(2),
          ""
        );
        return `+${countryCode} ${formatedNumber}`;
      },
    },
    {
      align: "right",
      headerAlign: "right",
      field: "actions",
      headerName: " ",
      sortable: false,
      flex: 0.5,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "end",

              width: "100%",
            }}
          >
            <ButtonCancel
              style={{ alignSelf: "flex-end" }}
              startIcon={<Delete fill="#616161" />}
              onClick={() => {
                removeNumber(params.row.phoneNumber);
              }}
            >
              Remover
            </ButtonCancel>
          </div>
        );
      },
    },
  ];

  async function removeNumber(number) {
    try {
      setLoading(true);
      const response = await removeNumberBlocked(companyUser.document, number);
      if (response?.success) {
        setRows(rows.filter((row) => row.phoneNumber !== number));
        notify("Número removido com sucesso", true, "success");
      } else {
        notify(response?.error, true, "error");
      }
    } catch (e) {
      notify("Erro ao remover número", true, "error");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const initialSetup = async () => {
      try {
        const response = await getNumbersBlocked(companyUser.document);
        const data = response?.data?.map((item, index) => {
          return {
            id: index,
            phoneNumber: item.phoneNumber,
          };
        });

        setRows(data);
      } catch (e) {
        setRows([]);
        notify("Erro ao buscar números bloqueados", true, "error");
      } finally {
        setLoading(false);
      }
    };

    initialSetup().then(() => {
      setLoading(false);
    });

    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div style={{ display: "flex" }}>
        <Typography
          style={{
            fontSize: 16,
            fontWeight: 600,
            color: "#364461",
            marginTop: 16,
            marginBottom: 16,
          }}
        >
          Números que optaram por não receber mais notificações via WhatsApp
        </Typography>
      </div>

      <StyledDatagrid
        disableColumnMenu
        autoHeight
        loading={loading}
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 5 },
          },
        }}
        disableSelectionOnClick
        localeText={ptBR.props.MuiDataGrid.localeText}
        hideFooter
        style={{ minHeight: "80%", border: "0px !important" }}
        className={classes.root}
      />
    </>
  );
};

export default TabPanelBlockedNumbers;
